import React, { FC } from 'react'
import { Link } from '@mui/material'
import { Formik } from 'formik'
import { IFormProps, isMultiLoginApp } from 'utils'
import {
  Module,
  ModuleHeader,
  ModuleBody,
  CustomAlert,
  CustomTextField,
  PasswordComplexityRequirement,
  ButtonContainer,
  CustomButton,
} from 'components'

interface IAdditionalProps extends IFormProps {
  passwordPolicy: any
  handleCancel: (e: any) => void
}

const ChangePasswordForm: FC<IAdditionalProps> = ({
  isModuleInitialized,
  passwordPolicy,
  initialValues,
  validationSchema,
  handleSubmit,
  handleCancel,
  serviceError,
}) => (
  <Module isModuleInitialized={isModuleInitialized} serviceError={serviceError}>
    <ModuleHeader
      title={
        isMultiLoginApp()
          ? 'Change Password for Multi-Login'
          : 'Change Password'
      }
    >
      <CustomAlert severity="error">{serviceError}</CustomAlert>
    </ModuleHeader>

    <ModuleBody>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({
          handleSubmit: onSubmit,
          dirty,
          isValid,
          isSubmitting,
          getFieldProps,
          getFieldMeta,
          setFieldTouched,
          setFieldError,
          touched,
          errors,
          values,
        }) => (
          <form onSubmit={onSubmit}>
            <CustomTextField
              autoFocus
              id="oldPassword"
              type="password"
              label="Old Password"
              hasServiceError={Boolean(serviceError)}
              touched={touched}
              errors={errors}
              values={values}
              getFieldMeta={getFieldMeta}
              setFieldTouched={setFieldTouched}
              setFieldError={setFieldError}
              {...getFieldProps('oldPassword')}
            />

            <CustomTextField
              id="newPassword"
              type="password"
              label="Enter new password"
              hasServiceError={Boolean(serviceError)}
              touched={touched}
              errors={errors}
              values={values}
              getFieldMeta={getFieldMeta}
              setFieldTouched={setFieldTouched}
              setFieldError={setFieldError}
              {...getFieldProps('newPassword')}
            />

            <PasswordComplexityRequirement
              passwordPolicyComplexity={passwordPolicy?.complexity}
              newPassword={values.newPassword}
            />

            <CustomTextField
              id="repeatPassword"
              type="password"
              label="Confirm new password"
              hasServiceError={Boolean(serviceError)}
              touched={touched}
              errors={errors}
              values={values}
              getFieldMeta={getFieldMeta}
              setFieldTouched={setFieldTouched}
              setFieldError={setFieldError}
              {...getFieldProps('repeatPassword')}
            />

            <ButtonContainer
              primary={
                <CustomButton
                  type="submit"
                  disabled={!dirty || !isValid || isSubmitting}
                >
                  Change Password
                </CustomButton>
              }
              secondary={
                <Link href="/login" onClick={handleCancel} color="primary">
                  Return to Login
                </Link>
              }
            />
          </form>
        )}
      </Formik>
    </ModuleBody>
  </Module>
)

export default ChangePasswordForm
